import React from 'react';
import styled from 'styled-components';
import { minBp, maxBp } from 'src/lib/theme';
import { ConfigOptionsBackButtonWrapper, ConfigOptionsBackButton } from 'components/Tray/Tray.styled';
import _ChevronRightIcon from 'src/assets/icons/chevron-right.svg';
import Container from 'components/_utility/Container';

export const ActiveFiltersOuter = styled.div`
  ${({ hideOnMobile }) => `
    flex: 1;
    display: ${hideOnMobile ? 'none' : 'block'};

    @media ${minBp('tabletLarge')} {
      display: block;
    }
  `}
`;

export const Wrap = styled.div`
  ${({ visible, filterOpen }) => `  
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    width: 100%;
    z-index: 100;
    padding: 60px 0 60px;
    height: calc(100% - 60px);
    margin-top: 60px;
    display: ${visible ? 'flex' : 'none'};
    flex-direction: column;

    @media ${minBp('tabletLarge')} {
      position: absolute;
      width: 100%;
      bottom: 100px;
      top: auto;
      left: auto;
      background-color: transparent;
      height: auto;
      z-index: 2;
      padding: 0;
      display: block;
    }

    ${ActiveFiltersOuter} {
      @media ${minBp('tabletLarge')} {
        display: none;        
      }
    }
  `}
`;

export const FilterCards = styled.div`
  display: flex;
  flex-direction: column;

  @media ${minBp('tabletLarge')} {
    flex-direction: row;
    justify-content: center;
  }
`;

export const Card = styled.div`
  ${({ active }) => `
    display: flex;
    font-size: 16px;
    padding: 9px 0;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 4px;
    position: relative;
    align-items: center;

    @media ${minBp('additional.mobile')} {
      padding: 12px 0;
    }

    @media ${minBp('tabletLarge')} {
      margin: 0 30px;
      width: 160px;
      height: 160px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: ${active ? 'black' : 'white'};
      color: ${active ? 'white' : 'black'};
      box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.1);
      font-size: 14px;
      cursor: pointer;
      padding: 0;
      border: 0;
    }
  `}
`;

export const CardIcon = styled.div`
  ${({ active }) => `
    svg {
      margin: 0 18px 0 0;
      vertical-align: middle;
      position: relative;
      bottom: 2px;
      width: 32px;
      height: 32px;
    }

    @media ${minBp('additional.mobile')} {
      svg {
        width: 35px;
        height: 35px;
      }
    }

    @media ${minBp('tabletLarge')} {
      svg {
        margin: 0 0 15px;
        vertical-align: middle;
        width: 60px;
        height: 60px;
        position: relative;
        right: auto;
        bottom: auto;

        path {
          fill: ${active ? 'white' : 'black'};
        }
      }
    }
  `}
`;

export const CardWrap = styled.div`
  ${({ active }) => `
    position: relative;

    @media ${minBp('tabletLarge')} {
      z-index: ${active ? 11 : 12};
    }
  `}
`;

export const TitleBar = styled.div`
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: 17px;
  background-color: #eeeeee;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  line-height: 1;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 4px 24px 0;
  position: absolute;

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 20px;
  appearance: none;
  border: 0;
  background-color: transparent;
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ApplyButtonWrapper = styled(ConfigOptionsBackButtonWrapper)`
  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const ApplyButton = styled(ConfigOptionsBackButton)``;

export const ResultsBar = styled.div`
  padding-top: 18px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const ResultsCount = styled.div`
  font-size: 16px;
  color: #000;
  position: relative;
  top: 2px;
`;

export const ResetButton = styled.button`
  appearance: none;
  border: 0;
  border-radius: 4px;
  padding: 5px 7px;
  font-size: 12px;
  background-color: #eaeaea;
  color: #585a5f;

  svg {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    margin-right: 3px;

    path {
      fill: #585a5f;
    }
  }
`;

export const ChevronRightIcon = styled(_ChevronRightIcon)`
  vertical-align: middle;
  width: 16px;
  height: 16px;
  position: absolute;
  right: 4px;
  margin: 0;

  path {
    fill: #000;
  }

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const RefineResults = styled.div`
  ${({ filterOpen }) => `
    padding: 25px 30px 0;
    display: flex;

    @media ${minBp('tabletLarge')} {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: ${filterOpen ? 1 : 3};
      padding: 0;
    }
  `}
`;

export const RefineResultsInner = styled(Container)`
  ${({ fluid }) => `
    display: flex;
    width: 100%;

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      padding: ${fluid ? '0' : '0 16px !important'};
    }

    @media ${minBp('tabletLarge')} {
      ${
        fluid
          ? `
        max-width: 100%;
        padding-right: 70px;
      `
          : `
        padding: 0 30px;
      `
      }
    }

    @media ${minBp('desktop')} {
      ${
        fluid
          ? `
        padding: 0 70px 0 0;
      `
          : `
        padding: 0;
      `
      }
    }
  `}
`;

export const FilterButton = styled.button`
  appearance: none;
  border: 1px solid #000;
  padding: 10px 15px;
  color: #000;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: inherit;
  position: relative;
  margin-right: 4px;
  flex: 1;
  min-width: calc(50% - 4px);
  height: 40px;
  font-size: 16px;

  svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    top: 8px;
    right: 15px;

    path {
      fill: #000;
    }
  }

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const FiltersBody = styled.div`
  padding: 26px;
  flex: 1;
  height: calc(100% - 60px);
  overflow: auto;

  @media ${minBp('tabletLarge')} {
    padding: 0;
    flex: none;
    height: auto;
    overflow: visible;
  }
`;
